import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from './auth';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await adminLogin(email, password);
      navigate('/admin');
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Credenziali non valide.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0B0C] p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#141417] border border-white/10 rounded-lg p-8">
        <div className="text-center mb-6">
          <img src="/img/INSOLITA_SARDEGNA_LOGO_MOTOCLUB-white.svg" alt="Insolita Sardegna" className="h-14 mx-auto mb-4" />
          <h1 className="text-[#E4FF1A] uppercase tracking-wide text-sm font-semibold">Dashboard</h1>
        </div>
        <label className="block text-xs uppercase tracking-wide text-white/50 mb-1">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full mb-4 px-3 py-3 bg-[#0B0B0C] border border-white/15 rounded text-white focus:border-[#E4FF1A] outline-none" />
        <label className="block text-xs uppercase tracking-wide text-white/50 mb-1">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full mb-5 px-3 py-3 bg-[#0B0B0C] border border-white/15 rounded text-white focus:border-[#E4FF1A] outline-none" />
        {error && <p className="text-red-400 text-sm mb-4">{error}</p>}
        <button type="submit" disabled={loading}
          className="w-full py-3 bg-[#E4FF1A] text-[#0B0B0C] font-semibold uppercase tracking-wide text-sm rounded disabled:opacity-60">
          {loading ? 'Accesso…' : 'Accedi'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
